export default __webpack_public_path__ + "static/media/usd.1f2ef78c.svg";